import { graphql } from 'react-relay';

import CanonicalCategory from './containers/CanonicalCategory';
import CanonicalIssuesTable from './containers/CanonicalIssuesTable';
import BrokenHreflangIssuesTable from './containers/BrokenHreflangIssuesTable';

import { createRenderFunction } from '../../utils/redirects';

export default ({
  path: 'canonical',
  Component: CanonicalCategory,
  query: graphql`
    query canonical_CanonicalCategory_Query($host: String!) {
      project(host: $host) {
        ...CanonicalCategory_project
      }
    }
  `,
  render: createRenderFunction({ redirectTo: '/canonical-issues' }),
  children: [
    {
      Component: CanonicalIssuesTable,
      path: 'canonical-issues',
      query: graphql`
        query canonical_CanonicalCategory_CanonicalIssuesTable_Query($host: String!) {
          project(host: $host) {
            ...CanonicalIssuesTable_project
          }
        }
      `
    },
    {
      Component: BrokenHreflangIssuesTable,
      path: 'broken-hreflang-issues',
      query: graphql`
        query canonical_CanonicalCategory_BrokenHreflangIssuesTable_Query($host: String!) {
          project(host: $host) {
            ...BrokenHreflangIssuesTable_project
          }
        }
      `
    }
  ]
});
